import { CourseType, Courses, CoursesListParamsType } from "@/types/Courses";
import { getConfig } from "@/utils/config";
import { HttpResponse } from "@/utils/http-client";
import useSWR from "swr";

export function useGetCourses({
  path = "",
  discipline = "",
  title = "",
  type = "",
  skill_area,
}: CoursesListParamsType) {
  return useSWR<CourseType[], HttpResponse<any, any>>(
    "getCourses" + path + title + type + discipline + skill_area,
    async () => {
      const params = { path, title, type, discipline, skill_area };
      for (const key of Object.keys(params)) {
        if (!params[key as keyof typeof params]) {
          delete params[key as keyof typeof params];
        }
      }
      const courses = new Courses(getConfig());
      return (await courses.coursesList(params)).data;
    },
    {
      revalidateOnFocus: false,
    }
  );
}
